import { render } from "./IconSearch.vue?vue&type=template&id=294ab7f4"
import script from "./IconSearch.vue?vue&type=script&lang=ts"
export * from "./IconSearch.vue?vue&type=script&lang=ts"
script.render = render

export default script